import React, { PureComponent } from 'react';
import { SofaButton, SofaPopup } from '@sofology/sofologycomponents';

import './BasketModal.scss';

const DEFAULT_TITLE = 'Sorry, your reservation has expired and one or more items have been removed from your basket';

interface OwnProps {
    open: boolean;
    onClick: () => void;
    title?: string;
}

class BasketModal extends PureComponent<OwnProps> {
    render(): JSX.Element {
        const { open, onClick, title } = this.props;

        return (
            <SofaPopup open={open} message={title ?? DEFAULT_TITLE}>
                <div className='basket-modal__content'>
                    <SofaButton variant='secondary' onClick={onClick} text='Ok' />
                </div>
            </SofaPopup>
        );
    }
}

export default BasketModal;